import {
    AuthenticationService,
    ContentService,
    DistanceService,
    NotificationService,
    OrderService,
    StatusService,
    TransportDeviationService,
    TransportExecuteService,
    TransportLoadService,
    TransportLoadActionService,
    TransportTaskService,
    TransportTaskActionService,
    TransportTaskPlanService,
    TransportTaskTypeService,
    TransportUnitService,
    TransportUnitTypeService,
    TransportVehicleService,
    TermsOfUseService,
    WastePartService,
    WaybillManageService,
    PackagingTypeService,
    WasteCodeService,
} from "./models";

import axios from "axios";
import { CancelToken } from "axios";

const parts = location.host.split(".");
parts[0] = "api";

const apiRoot = location.protocol + "//" + parts.join(".") + "/";

const axiosInstance = axios.create({
    baseURL: apiRoot,
    withCredentials: true,
});

class JsonRpcException extends Error {
    constructor(public error: string, public path: string, public method: string) {
        super();
    }
}

const serviceInvokeErrors: JsonRpcException[] = [];
const serviceErrorHandlers: Array<(e: JsonRpcException) => void> = [];

function onUnhandledServiceError(handler: (e: JsonRpcException) => void): void {
    serviceErrorHandlers.push(handler);
}

function invoker(path: string) {
    return async (name: string, args: object, cancelToken?: CancelToken) => {
        let data;

        try {
            const response = await axiosInstance.post("private/" + path, {
                jsonrpc: "2.0",
                method: name,
                params: args,
            }, {
                    cancelToken
                });

            data = response.data;
        } catch (e) {
            if (e.response && e.response.data && e.response.data.jsonrpc && e.response.data.error) {
                data = e.response.data;
            } else {
                throw e;
            }
        }

        if (data.error) {
            const error = new JsonRpcException(data.error, path, name);
            serviceInvokeErrors.push(error);

            setTimeout(() => {
                const index = serviceInvokeErrors.findIndex(e => e === error);
                if (index === -1) {
                    return;
                }

                for (const handler of serviceErrorHandlers) {
                    handler(error);
                }
            }, 1);

            throw error;
        }

        return data.result;
    };
}

const authenticationService = new AuthenticationService(invoker("authentication"));
const contentService = new ContentService(invoker("content"));
const distanceService = new DistanceService(invoker("distance"));
const notificationService = new NotificationService(invoker("notification"));
const orderService = new OrderService(invoker("order"));
const packagingTypeService = new PackagingTypeService(invoker("packagingtype"));
const statusService = new StatusService(invoker("status"));
const termsOfUseService = new TermsOfUseService(invoker("termsofuse"));
const transportDeviationService = new TransportDeviationService(invoker("transportdeviation"));
const transportExecuteService = new TransportExecuteService(invoker("transportexecute"));
const transportLoadService = new TransportLoadService(invoker("transportload"));
const transportLoadActionService = new TransportLoadActionService(invoker("transportloadaction"));
const transportTaskService = new TransportTaskService(invoker("transporttask"));
const transportTaskActionService = new TransportTaskActionService(invoker("transporttaskaction"));
const transportTaskPlanService = new TransportTaskPlanService(invoker("transporttaskplan"));
const transportTaskTypeService = new TransportTaskTypeService(invoker("transporttasktype"));
const transportUnitService = new TransportUnitService(invoker("transportunit"));
const transportUnitTypeService = new TransportUnitTypeService(invoker("transportunittype"));
const transportVehicleService = new TransportVehicleService(invoker("transportvehicle"));
const wasteCodeService = new WasteCodeService(invoker("wastecode"));
const waybillManageService = new WaybillManageService(invoker("waybillmanage"));

export {
    apiRoot,
    axiosInstance,
    onUnhandledServiceError,
    JsonRpcException,

    authenticationService,
    contentService,
    distanceService,
    notificationService,
    orderService,
    packagingTypeService,
    statusService,
    termsOfUseService,
    transportDeviationService,
    transportExecuteService,
    transportLoadService,
    transportLoadActionService,
    transportTaskService,
    transportTaskActionService,
    transportTaskPlanService,
    transportTaskTypeService,
    transportUnitService,
    transportUnitTypeService,
    transportVehicleService,
    wasteCodeService,
    waybillManageService
};
